module.exports = __webpack_public_path__ + "static/media/cucumbers.e81a48b4.png";